export default "__VITE_ASSET__LBXD2KS1__"